import { UIChart } from '../chart/ui-chart';
import { Component } from '../../../shared-components/decorators/component.decorator';
import styles from './ui-chart-line.css';

/**
 * @class
 * @memberof ChartsComponents
 * @element ui-chart-line
 * @augments {UIChart}
 * @alias UIChartLine
 * @classdesc Represents a class for <code>ui-chart-line</code> element.
 * Draws line type chart.
 * @slot {@type "ui-series"}
 * @example
 * <ui-chart-line preset="interactive">
 *   <ui-series data="[10, 25, 50, 33, 43, 98]"></ui-series>
 *   <ui-series data="[77, 3, 32, 33 , 5.4]"></ui-series>
 * </ui-chart-line>
 */
@Component({ tag: 'ui-chart-line', styles })
export class UIChartLine extends UIChart {
    override get type(): string {
        return 'line';
    }

    /**
     * @inheritDoc
     */
    override renderChart(): void {
        this.mergeOptionsFromElement();
        this.draw({
            xAxis: {
                tickmarkPlacement: 'on',
            },
            tooltip: {
                enabled: true,
            },
            plotOptions: {
                series: {
                    enableMouseTracking: true,
                    dataLabels: {
                        enabled: false,
                    },
                    legendSymbol: 'lineMarker',
                },
            },
        });
    }
}
